<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  components: {
    DataGrid,
  },
  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "MiddlewareOfAccessToTadbir/api/CustomersQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
};
</script>
